module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/target03-aed116b9482449e2c08afd8b856e8495.png";